import { render, staticRenderFns } from "./Dmduplicates.vue?vue&type=template&id=0f389be8"
import script from "./Dmduplicates.vue?vue&type=script&lang=js"
export * from "./Dmduplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports